<template>
  <div>
    <a-modal
      :title="title"
      :visible="visible"
      width="450px"
      @ok="handleSubmit"
      @cancel="handleCancel"
    >
      <a-form
        @submit="handleSubmit"
        :form="form"
      >
        <a-row>
          <a-col :span="24">
            <a-form-item
              label="头像"
              :labelCol="{lg: {span: 6}}"
              :wrapperCol="{lg: {span: 18} }"
              style="margin-bottom:5px;"
            >
              <upload ref="upload" :length="1" :imgs="image" @uploadSuccess="uploadSuccess" :cutImg="true" uploadTest="头像" :fixedNumber="[5,7]"></upload>
            </a-form-item>
            <a-form-item
                label="姓名"
                :labelCol="{lg: {span: 6}}"
                :wrapperCol="{lg: {span: 18} }"
            >
              <a-input placeholder="请输入运动员姓名" v-decorator="['name', { rules: [{required: true, message: '请输入运动员姓名!'}]}]"/>
            </a-form-item>
            <a-form-item
                label="国籍"
                :labelCol="{lg: {span: 6}}"
                :wrapperCol="{lg: {span: 18} }"
            >
              <a-select
                v-decorator="['nationality',{ rules: [{ required: true, message: '请选择国籍!' }] },]"
                placeholder="请选择国籍"
                @change="changeNationality"
              >
                <a-select-option v-for="(item, index) in nationalityArr" :key="index" :value="item.name">
                  {{ item.name }}|{{ item.english }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item
                label="人员类型"
                :labelCol="{lg: {span: 6}}"
                :wrapperCol="{lg: {span: 18} }"
            >
              <a-select
                v-decorator="['type',{ rules: [{ required: true, message: '请选择人员类型!' }] },]"
                placeholder="请选择人员类型"
              >
                <a-select-option :value="0">
                  默认运动员
                </a-select-option>
                <a-select-option v-for="(item, index) in PlayerType" :key="index" :value="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item
                v-if="nationalityNot"
                label="出生年月"
                :labelCol="{lg: {span: 6}}"
                :wrapperCol="{lg: {span: 18} }"
            >
              <a-date-picker v-decorator="['birthday', {rules: [{ type: 'object', required: true, message: '请选择出生年月!' }]}]" />
            </a-form-item>
            <a-form-item
                v-if="nationalityNot"
                label="性别"
                :labelCol="{lg: {span: 6}}"
                :wrapperCol="{lg: {span: 18} }"
            >
              <a-radio-group v-decorator="['sex', {rules: [{ required: true, message: '请选择性别!' }]}]">
                <a-radio :value="1">
                  男
                </a-radio>
                <a-radio :value="2">
                  女
                </a-radio>
              </a-radio-group>
            </a-form-item>
            <a-form-item
                :label="nameStr"
                :labelCol="{lg: {span: 6}}"
                :wrapperCol="{lg: {span: 18} }"
            >
              <a-input :disabled="cardDisabled" :placeholder="'请输入运动员' + nameStr" v-decorator="['card', { rules: [{required: true, message: '请输入运动员' + nameStr}]}]"/>
            </a-form-item>
            <a-form-item
                label="联系电话"
                :labelCol="{lg: {span: 6}}"
                :wrapperCol="{lg: {span: 18} }"
            >
              <a-input placeholder="请输入联系电话" v-decorator="['guardianPhone']"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import PlayerType from '@comm/config/high-tech/PlayerType'
import { mapState } from 'vuex'
import moment from 'moment'
import nationalityUtil from '@comm/utils/nationalityUtil'
import { checkIdCard, getSex, getBirthday } from '@comm/utils/IdCardUtils'
import matchFun from '@comm/utils/matchFun'
import Upload from '@comm/upload/Upload'
import address from '@comm/utils/address'
export default {
  components: {
    Upload
  },
  data () {
    return {
      form: this.$form.createForm(this),
      visible: false,
      address: address,
      PlayerType: PlayerType,
      image: [],
      nationalityArr: nationalityUtil,
      matchFun: matchFun,
      data: null,
      id: null,
      nameStr: '身份证号',
      title: '新增运动员',
      cardDisabled: false,
      nationalityNot: false
    }
  },
  computed: {
    ...mapState({
      agencyInfo: state => state.agency.agencyInfo
    })
  },
  methods: {
    moment,
    show (data) {
      this.id = null
      this.nationalityNot = false
      this.data = data
      this.image = []
      this.visible = true
      this.cardDisabled = this.data !== null
      if (data !== null) {
        this.id = data.id
        this.title = '修改运动员信息'
        this.changeNationality(data.nationality)
        this.image.push(this.matchFun.randomNumFile('image.jpg', data.image))
      }
      this.$nextTick(function () {
        this.formData(this.data)
      })
    },
    formData (data) {
      this.form.setFieldsValue({
        name: data === null ? '' : data.name,
        card: data === null ? '' : data.card,
        nationality: data === null ? '中国大陆' : data.nationality,
        type: data === null ? 0 : data.type,
        guardianPhone: data === null ? '' : data.guardianPhone
      })
      if (this.nationalityNot) {
        this.form.setFieldsValue({
          birthday: moment(this.matchFun.formatDate(data.birthday, false), 'YYYY-MM-DD'),
          sex: data === null ? 1 : data.sex
        })
      }
    },
    uploadSuccess (e) {
      this.image = e
    },
    changeNationality (e) {
      this.nationalityNot = e !== '中国大陆'
      this.nameStr = this.nationalityNot ? '护照号' : '身份证号'
    },
    handleSubmit (e) {
      e.preventDefault()
      if (this.image.length === 0) {
        this.$message.error('请上传头像')
        return
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          if (!this.nationalityNot) {
            if (!checkIdCard(values.card)) {
              this.$message.error('身份证不合法')
              return
            }
            values.sex = getSex(values.card)
            values.birthday = getBirthday(values.card) + ' 00:00:00'
            // 去除空格
            values.name = values.name.replace(/\s+/g, '')
          } else {
            values.birthday = this.matchFun.formatDate(values.birthday, true)
            // 去除两边的空格
            values.name = values.name.trim()
            values.card = values.card.replace(/\s+/g, '')
          }
          
          if (this.id !== null) {
            values.agencyId = this.data.agencyId
          } else {
            values.agencyId = this.agencyInfo.agencyId
          }
          values.image = this.image[0].url
          values.id = this.id
          this.$api.match.playerSave(values).then(res => {
            if (res.status === 0) {
              this.$message.success('成功')
              this.$emit('ok')
              this.handleCancel()
            } else {
              this.$message.error(res.msg)
            }
          }).catch(err => {
            console.log(err)
          })
        }
      })
    },
    handleCancel () {
      this.visible = false
    },
    formatDate (value) {
      var date = new Date(value)// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
      var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
      var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
      return Y + M + D + h + m + s
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/comm/components/center/modal/EditPlayer.vue